import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useContext, useState } from "react";
import ReactDOM from "react-dom";
import { AnimatePresence } from "framer-motion";
import { PortalRootContext } from "../portal-root/PortalRootContext";
import { DialogHeader } from "./DialogHeader";
import { DialogBody } from "./DialogBody";
import { DialogFooter } from "./DialogFooter";
import { DialogInner } from "./DialogInner";
const DialogComponent = forwardRef((props, ref) => {
    const portalRoot = useContext(PortalRootContext);
    const [isFocusTrapActive, setIsFocusTrapActive] = useState(false);
    /* istanbul ignore next */
    const { buttonLayout = "default", isOpen = false, onClose = () => { }, scrimStyle = "dark", ...innerProps } = props;
    if (!portalRoot) {
        return null;
    }
    return (
    // TODO: Remove this Fragment when https://github.com/reactjs/react-docgen/issues/336 is resolved
    _jsx(_Fragment, { children: ReactDOM.createPortal(_jsx(AnimatePresence, { initial: process.env.NODE_ENV !== "test", onExitComplete: () => setIsFocusTrapActive(false), children: isOpen && (_jsx(DialogInner, { isFocusTrapActive: isFocusTrapActive, ref: ref, setIsFocusTrapActive: setIsFocusTrapActive, buttonLayout: buttonLayout, onClose: onClose, "data-testid": "Dialog", scrimStyle: scrimStyle, ...innerProps })) }), portalRoot) }));
});
DialogComponent.displayName = "Dialog";
DialogComponent.defaultProps = {
    buttonLayout: "default",
    hasCloseIcon: false,
    isCentered: false,
    isOpen: false,
    onClose: () => { },
    focusTrapOptions: {},
    scrimStyle: "dark",
    shouldCloseOnEsc: true,
    shouldCloseOnOutsideClick: true,
    width: 400
};
export const Dialog = Object.assign(DialogComponent, {
    Header: DialogHeader,
    Body: DialogBody,
    Footer: DialogFooter,
    /* Exporting DialogInner for usage in the Alchemy Guide table of contents card */
    Root: DialogInner
});
